import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header2 } from "../../componentes/header/Header2";
import { DepositBank } from "../../componentes/ListaOrdenes/DepositBank";
import MapComponent from "../../componentes/ListaOrdenes/MapComponent";
import OrderTimeline from "./timeline";
import NPSModal from "../nps/NPSModal";
import { useLocalStorageExpire } from "../hooks/useLocalStorageExpire";
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import "./ResumenPedido.css";

const IconBank = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="22" x2="21" y2="22" />
    <line x1="6" y1="18" x2="6" y2="11" />
    <line x1="10" y1="18" x2="10" y2="11" />
    <line x1="14" y1="18" x2="14" y2="11" />
    <line x1="18" y1="18" x2="18" y2="11" />
    <polygon points="12 2 2 7 22 7" />
  </svg>
);

const IconPin = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconStore = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l1-5h16l1 5" />
    <path d="M3 9a2 2 0 004 0 2 2 0 004 0 2 2 0 004 0 2 2 0 004 0" />
    <rect x="5" y="13" width="14" height="8" rx="1" />
    <line x1="9" y1="13" x2="9" y2="21" />
  </svg>
);

const IconCardSmall = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
    <rect x="4" y="13" width="5" height="3" rx="1" />
  </svg>
);

const IconChevronDown = ({ size = 14, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color || "currentColor"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const IconChevronUp = ({ size = 14, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color || "currentColor"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15" />
  </svg>
);

const IconShoppingBag = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 01-8 0" />
  </svg>
);

const IconTruck = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" rx="1" />
    <path d="M16 8h4l3 5v4h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const IconCheckCircle = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const IconFlame = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2c0 6-6 8-6 13a6 6 0 0012 0c0-5-6-7-6-13z" />
    <path d="M12 12c0 3-2 4-2 6a2 2 0 004 0c0-2-2-3-2-6z" />
  </svg>
);

const IconBike = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5.5" cy="17.5" r="3.5" />
    <circle cx="18.5" cy="17.5" r="3.5" />
    <path d="M15 6h-3l-3 11.5" />
    <path d="M9 6l4.5 6H18.5" />
    <path d="M6 10l3-4" />
  </svg>
);

const IconStar = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const STATUS_HERO = {
  1: { Icon: IconCheckCircle, title: "¡Pedido aceptado!", sub: "Ya lo recibimos, en un momento comenzamos." },
  5: { Icon: IconFlame, title: "En cocina", sub: "Estamos preparando tu pedido con amor." },
  7: { Icon: IconBike, title: "¡Va en camino!", sub: "Tu pedido está siendo entregado." },
  9: { Icon: IconStar, title: "¡Entregado!", sub: "Esperamos que lo disfrutes mucho." },
};

const IconX = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

// PLZ-112: estados fuera del avance normal. No llenan el timeline.
// Antes caían en "s >= 9" y mostraban "¡Entregado!".
const STATUS_SPECIAL = {
  10: { Icon: IconX, title: "Pedido cancelado", sub: "Si tienes dudas, comunícate con el comercio." },
  12: { Icon: IconCheckCircle, title: "Pedido programado", sub: "Lo prepararemos para la fecha y hora que elegiste." },
  100: { Icon: IconCheckCircle, title: "Esperando confirmación de pago", sub: "Apenas el comercio confirme tu pago, empezamos." },
};

// Status real -> paso del timeline (1 aceptado, 5 cocina, 7 en camino, 9 entregado)
const STEP_BY_STATUS = { 1: 1, 2: 1, 3: 1, 4: 1, 5: 5, 6: 5, 7: 7, 8: 9, 9: 9 };

const toTimelineStep = (status) => {
  const s = parseInt(status, 10);
  if (STATUS_SPECIAL[s]) return 0;
  return STEP_BY_STATUS[s] || 1; // status desconocido -> "Aceptado", nunca "Entregado"
};

const getHero = (status) => {
  const s = parseInt(status, 10);
  if (STATUS_SPECIAL[s]) return STATUS_SPECIAL[s];
  return STATUS_HERO[toTimelineStep(s)];
};

export const ResumenPedido = ({ propiedadesCompany }) => {
  const { dataConfig } = configShop();
  const [npsStatus, setNpsStatus] = useLocalStorageExpire("NpsStatus", true, 720000);
  const [openNPS, setOpenNPS] = useState(false);
  const { idDetalle } = useParams();

  const [detailOrder, setDetailOrder] = useState({});
  const [detailOrderItems, setDetailOrderItems] = useState([]);
  const [detailOrderBranch, setDetailOrderBranch] = useState({});
  const [detailOrderClient, setDetailOrderClient] = useState({});
  const [wireTransfer, setWireTransfert] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [openMap, setOpenMap] = useState(false);
  const [openDeposit, setOpenDeposit] = useState(false);

  const brandColor = dataConfig?.page_menu?.button?.color;
  const brandText = dataConfig?.page_menu?.button?.color_text;

  useEffect(() => {
    if (npsStatus === true) {
      setOpenNPS(true);
      setNpsStatus(false);
    }
  }, [npsStatus]);

  const curlDetailOrder = async () => {
    const url = `https://dev-api.menu.iguarayalabs.com/detail-order/${idDetalle}`;
    const pleiztUuid = localStorage.getItem("pleiztUuid");
    const res = await apiGet(`/detail-order/${idDetalle}`);
   /* const res = await fetch(url, {
      method: "get",
      headers: new Headers({ "pleizt-uuid-new": pleiztUuid }),
    }).then((r) => r.json());*/

    setDetailOrder(res.data);
    setDetailOrderItems(res.data.items || []);
    setDetailOrderBranch(res.data.branch || {});
    setDetailOrderClient(res.data.client || {});
    setWireTransfert(res.data?.wire_transfer || {});
    setCurrentStep(res.data?.status);
  };

  useEffect(() => {
    curlDetailOrder();
    const interval = setInterval(curlDetailOrder, 10000);
    return () => clearInterval(interval);
  }, []);

  const hero = getHero(currentStep);
  const hasMap = detailOrderBranch?.longitude !== undefined && detailOrder.status < 9;
  const isDeposit = detailOrder.payment_method === "bank_deposit";

  return (
    <div className="App">
      <div className="rp-page">
        <header className="App-header">
          <Header2 propiedadesCompany={propiedadesCompany} />
        </header>

        <div className="rp-scroll">

          {/* ── Status 100: pendiente de pago → mostrar datos bancarios primero, sin hero ── */}
          {isDeposit && detailOrder.status === "100" ? (
            <div className="rg-section-card">
              <div className="rg-section-header">
                <span className="rg-section-icon" style={{ color: brandColor }}><IconBank size={18} /></span>
                <span className="rg-section-title">Datos para el pago</span>
              </div>
              <DepositBank
                bank={wireTransfer?.bank}
                number_acount={wireTransfer?.number_acount}
                type_acount={wireTransfer?.type_acount}
                total_value={detailOrder.total_value}
                imageUrl={wireTransfer?.qr_pay}
                idDetalle={idDetalle}
              />
            </div>
          ) : (
            /* ── Hero (cualquier otro estado) ── */
            <div className="rp-hero" style={{ "--brand": brandColor, "--brand-text": brandText }}>
              <div className="rp-hero-emoji" style={{ color: brandColor }}><hero.Icon size={44} /></div>
              <h1 className="rp-hero-title">{hero.title}</h1>
              <p className="rp-hero-sub">{hero.sub}</p>
              <span className="rp-order-pill" style={{ "--brand": brandColor, "--brand-text": brandText }}>
                # {detailOrder.service_id}
              </span>
            </div>
          )}

          {/* ── Timeline ── */}
          <div className="rg-section-card">
            <OrderTimeline currentStep={toTimelineStep(currentStep)} />
          </div>

          {/* ── Depósito bancario colapsado (aceptado pero aún no en cocina) ── */}
          {isDeposit && detailOrder.status !== "100" && parseInt(detailOrder.status) < 5 && (
            <div className="rg-section-card rp-collapsible">
              <button
                className="rp-collapsible-header"
                onClick={() => setOpenDeposit(!openDeposit)}
              >
                <span className="rp-collapsible-title">
                  <span style={{ color: brandColor }}><IconBank size={16} /></span> Datos para el pago
                </span>
                {openDeposit ? <IconChevronUp size={14} color="#8888A0" /> : <IconChevronDown size={14} color="#8888A0" />}
              </button>
              {openDeposit && (
                <div className="rp-collapsible-body">
                  <DepositBank
                    bank={wireTransfer?.bank}
                    number_acount={wireTransfer?.number_acount}
                    type_acount={wireTransfer?.type_acount}
                    total_value={detailOrder.total_value}
                    imageUrl={wireTransfer?.qr_pay}
                    idDetalle={idDetalle}
                  />
                </div>
              )}
            </div>
          )}

          {/* ── Seguimiento / Mapa ── */}
          {hasMap && (
            <div className="rg-section-card rp-collapsible">
              <button
                className="rp-collapsible-header"
                onClick={() => setOpenMap(!openMap)}
              >
                <span className="rp-collapsible-title">
                  <span style={{ color: brandColor }}><IconPin size={16} /></span> Seguimiento del pedido
                </span>
                {openMap ? <IconChevronUp size={14} color="#8888A0" /> : <IconChevronDown size={14} color="#8888A0" />}
              </button>
              {openMap && (
                <div className="rp-collapsible-body rp-map-wrap">
                  <MapComponent detailOrder={detailOrder} />
                </div>
              )}
            </div>
          )}

          {/* ── Info de entrega ── */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <span className="rg-section-icon" style={{ color: brandColor }}><IconTruck size={18} /></span>
              <span className="rg-section-title">Datos de entrega</span>
            </div>
            <div className="rp-info-rows">
              <div className="rp-info-row">
                <span className="rp-info-icon" style={{ color: brandColor, display: "flex" }}><IconStore size={14} /></span>
                <div>
                  <span className="rp-info-label">Sucursal</span>
                  <span className="rp-info-value">{detailOrderBranch?.name || "—"}</span>
                </div>
              </div>
              <div className="rp-info-row">
                <span className="rp-info-icon" style={{ color: brandColor, display: "flex" }}><IconPin size={14} /></span>
                <div>
                  <span className="rp-info-label">Dirección</span>
                  <span className="rp-info-value">{detailOrderClient?.address || "—"}</span>
                </div>
              </div>
              {detailOrder.payment_method && (
                <div className="rp-info-row">
                  <span className="rp-info-icon" style={{ color: brandColor, display: "flex" }}><IconCardSmall size={14} /></span>
                  <div>
                    <span className="rp-info-label">Método de pago</span>
                    <span className="rp-info-value">{detailOrder.payment_method_name || detailOrder.payment_method}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ── Productos ── */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <span className="rg-section-icon" style={{ color: brandColor }}><IconShoppingBag size={18} /></span>
              <span className="rg-section-title">Tu pedido</span>
            </div>
            <ul className="rp-items">
              {detailOrderItems.map((item) => (
                <li key={item.uuid} className="rp-item">
                  <div className="rp-item-qty" style={{ "--brand": brandColor, "--brand-text": brandText }}>
                    {item.quantity}
                  </div>
                  <img
                    src={item.photo}
                    alt={item.name}
                    className="rp-item-img"
                  />
                  <div className="rp-item-info">
                    <span className="rp-item-name">{item.name}</span>
                    {item.observation ? (
                      <span className="rp-item-obs">{item.observation}</span>
                    ) : null}
                  </div>
                  <span className="rp-item-price">
                    ${item.total_value?.toLocaleString()}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rp-bottom-spacer" />
        </div>

        {/* ── Footer fijo: resumen de costos ── */}
        <div className="dp-footer">
          <div className="dp-summary">
            <div className="dp-summary-row">
              <span>Subtotal</span>
              <span>{detailOrder.base_value}</span>
            </div>
            <div className="dp-summary-row">
              <span>Domicilio</span>
              <span>{detailOrder.delivery_value}</span>
            </div>
            <div className="dp-summary-divider" />
            <div className="dp-summary-row dp-summary-total">
              <span>Total</span>
              <span>{detailOrder.total_value}</span>
            </div>
          </div>
        </div>

        <NPSModal
          orderId={detailOrder.service_id}
          open={openNPS}
          onClose={() => setOpenNPS(false)}
        />
      </div>
    </div>
  );
};
